import { frameQuickTool } from '@blocksuite/hive-block-frame';
import { penSeniorTool } from '@blocksuite/hive-gfx-brush';
import { connectorQuickTool } from '@blocksuite/hive-gfx-connector';
import { mindMapSeniorTool } from '@blocksuite/hive-gfx-mindmap';
import { noteSeniorTool } from '@blocksuite/hive-gfx-note';
import { shapeSeniorTool } from '@blocksuite/hive-gfx-shape';
import { templateSeniorTool } from '@blocksuite/hive-gfx-template';
import { QuickToolExtension } from '@blocksuite/hive-widget-edgeless-toolbar';
import { html } from 'lit';

import { buildLinkDenseMenu } from './link/link-dense-menu.js';

const defaultQuickTool = QuickToolExtension('default', ({ block }) => {
  return {
    type: 'default',
    content: html`<edgeless-default-tool-button
      .edgeless=${block}
    ></edgeless-default-tool-button>`,
  };
});

const linkQuickTool = QuickToolExtension('link', ({ block, gfx }) => {
  return {
    content: html`<edgeless-link-tool-button
      .edgeless=${block}
    ></edgeless-link-tool-button>`,
    menu: buildLinkDenseMenu(block, gfx),
  };
});

export const quickTools = [
  defaultQuickTool,
  frameQuickTool,
  connectorQuickTool,
  linkQuickTool,
];

export const seniorTools = [
  noteSeniorTool,
  penSeniorTool,
  shapeSeniorTool,
  mindMapSeniorTool,
  templateSeniorTool,
];
